import { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';

const LoginForm = ({ onSubmit, isSubmitting }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [validated, setValidated] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const htmlForm = e.currentTarget;
    if (!htmlForm.checkValidity()) {
      setValidated(true);
      return;
    }
    onSubmit(username, password);
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <InputGroup>
          <Form.FloatingLabel label="Username" controlId="username">
            <Form.Control
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              disabled={isSubmitting}
              placeholder=""
              autoComplete="username"
            />
            <Form.Control.Feedback type="invalid">
              Username is required.
            </Form.Control.Feedback>
          </Form.FloatingLabel>
        </InputGroup>
      </Form.Group>

      <Form.Group className="mb-3">
        <InputGroup>
          <Form.FloatingLabel label="Password" controlId="password">
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isSubmitting}
              placeholder=""
              autoComplete="current-password"
            />
            <Form.Control.Feedback type="invalid">
              Password is required.
            </Form.Control.Feedback>
          </Form.FloatingLabel>
        </InputGroup>
      </Form.Group>

      <div className="d-grid mt-4">
        <Button variant="primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <LoadingSpinner inline message="Logging in..." />
          ) : (
            'Login'
          )}
        </Button>
      </div>
    </Form>
  );
};

export default LoginForm;
